<template>
  <div class="poll-section-header">
    <div class="poll-section-header__row">
      <span
        class="poll-section-header__badge"
        :style="{ 'background-color': badgeColor }"
        aria-hidden="true"
        >{{ number }}</span
      >
      <h2 class="poll-section-header__title">
        <span class="d-sr-only">Schritt {{ number }}: </span>{{ title }}
      </h2>
      <v-icon
        v-if="done"
        :color="badgeColor"
        class="poll-section-header__done"
        aria-label="erledigt"
        >mdi-check-circle</v-icon
      >
    </div>
    <!-- text comes from the instance config and may contain HTML (as introductionSteps did before) -->
    <div v-if="text" class="poll-section-header__text" v-html="text"></div>
  </div>
</template>

<script>
import Vue from "vue";

/**
 * Heading of one numbered poll section: number badge, title, optional check mark
 * once the section is completed and an optional instruction text placed directly
 * above the controls it refers to.
 */
export default Vue.extend({
  name: "PollSectionHeader",

  props: {
    number: { type: Number, required: true },
    title: { type: String, default: "" },
    text: { type: String, default: "" },
    done: { type: Boolean, default: false },
  },

  computed: {
    badgeColor() {
      return this.$vuetify.theme.themes.light.primary;
    },
  },
});
</script>

<style scoped>
.poll-section-header {
  margin: 12px 0 8px 0;
}
.poll-section-header__row {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.poll-section-header__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: white;
  font-weight: bold;
  font-size: 18px;
  flex-shrink: 0;
}
.poll-section-header__title {
  font-size: 1.35rem;
  line-height: 1.3;
  margin: 0;
}
.poll-section-header__done {
  font-size: 28px !important;
}
.poll-section-header__text {
  margin-top: 6px;
  max-width: 900px;
}
.poll-section-header__text >>> ul {
  margin-top: 4px;
  padding-left: 22px;
}
</style>
